export default __webpack_public_path__ + "6a3843749abf53e8325cc0d0594bd120.svg";